<template>
	<div class="content scroll-container" style="background: #f3f5f8;">
		<!-- 定制中心 -->
		<transition name="el-fade-in">
			<div id="loading" v-show="showLoading">
				<div id="loading-center">
					<div id="loading-center-absolute">
						<div class="object" id="object_one"></div>
						<div class="object" id="object_two" style="left:20px;"></div>
						<div class="object" id="object_three" style="left:40px;"></div>
						<div class="object" id="object_four" style="left:60px;"></div>
						<div class="object" id="object_five" style="left:80px;"></div>
					</div>
				</div>
			</div>
		</transition>
    <div class="custom-banner wow animate__animated animate__fadeInUp animate__delay-0.3s">
      <img src="../../static/images/custom/banner-zh.png" v-show="currlangs==0" >
      <img src="../../static/images/custom/banner-eng.png" v-show="currlangs==1" >
      <img src="../../static/images/custom/banner-sp.png" v-show="currlangs==2" >
    </div>
    <div class="container">
      <div class="technology-box">
        <div class="tech-title content-title">
          <h1 class="wow animate__animated animate__fadeInUp animate__delay-0.3s" tips="技术专利">{{ langs.cust10 }}</h1>
        </div>
        <div class="tech-text">
          <el-row :gutter="40" style="margin: 0px;">
            <el-col :xs="24" :md="12">
              <div class="tech-text-d">
                <el-row class="d-box">
                  <el-col :md="16" :xs="18">
                    <div class="d-title" tips="便携称重板">
                      {{ langs.cust11 }}
                      <p class="d-under"></p>
                    </div>
                    <div class="d-text" tips="本系列产品可采集重量，通过RS-485通讯协议可以组网使用。">{{ langs.cust12 }}</div>
                    <div class="d-text d-text-1" tips="设备自带级联端口">{{ langs.cust13 }}</div>
                  </el-col>
                  <el-col :md="8" :xs="6">
                    <div class="d-img">
                      <img src="../../static/images/custom/cd1.png">
                    </div>
                  </el-col>
                </el-row>
              </div>
            </el-col>
            <el-col :xs="24" :md="12">
              <div class="tech-text-d">
                <el-row class="d-box">
                  <el-col :md="16" :xs="18">
                    <div class="d-title" tips="充电控制板">
                      {{ langs.cust14 }}
                      <p class="d-under"></p>
                    </div>
                    <div class="d-text" tips="本系列产品">{{ langs.cust15 }}</div>
                    <div class="d-text d-text-1" tips="设备自带级联端口">{{ langs.cust13 }}</div>
                  </el-col>
                  <el-col :md="8" :xs="6">
                    <div class="d-img">
                      <img src="../../static/images/custom/cd2.png">
                    </div>
                  </el-col>
                </el-row>
              </div>
            </el-col>
            <el-col :xs="24" :md="12">
              <div class="tech-text-d">
                <el-row class="d-box">
                  <el-col :md="16" :xs="18">
                    <div class="d-title" tips="阅读器">
                      {{ langs.cust16 }}
                      <p class="d-under"></p>
                    </div>
                    <div class="d-text" tips="IC ID QR 条码 二维码">{{ langs.cust17 }}</div>
                    <div class="d-text d-text-1" tips="阅读识别">{{ langs.cust18 }}</div>
                  </el-col>
                  <el-col :md="8" :xs="6">
                    <div class="d-img">
                      <img src="../../static/images/custom/cd3.png">
                    </div>
                  </el-col>
                </el-row>
              </div>
            </el-col>
            <el-col :xs="24" :md="12">
              <div class="tech-text-d">
                <el-row class="d-box">
                  <el-col :md="16" :xs="18">
                    <div class="d-title" tips="多功能板">
                      {{ langs.cust19 }}
                      <p class="d-under"></p>
                    </div>
                    <div class="d-text" tips="一种集开锁、照明、加热于一体的多功能控制电路">{{ langs.cust20 }}</div>
                  </el-col>
                  <el-col :md="8" :xs="6">
                    <div class="d-img">
                      <img src="../../static/images/custom/cd4.png">
                    </div>
                  </el-col>
                </el-row>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
      <div class="focus-box" style="margin-bottom: 50px;">
        <div class="focus-title content-title">
          <h1 class="wow animate__animated animate__fadeInUp animate__delay-0.3s" tips="专注更专业">{{ langs.cust21 }}</h1>
          <div class="wow animate__animated animate__fadeInUp animate__delay-0.3s" tips="根据市场需求 解决行业痛点">{{ langs.cust22 }}</div>
        </div>
        <div class="focus-img focus-img-bg">
          <div class="focus-img-t">
            <ul>
              <li :class="customindex==0?'custom-sign':'custom-sign-hide'" @click="selectCustomSign(0)">
                <img src="../../static/images/custom/ft1.png" class="focus-img-f" v-show="customindex==0">
                <img src="../../static/images/custom/ft1-1.png" class="focus-img-f" v-show="customindex!=0">
                <span class="focus-img-text" tips="智能餐柜">{{ langs.cust23 }}</span>
              </li>
              <li :class="customindex==1?'custom-sign':'custom-sign-hide'" @click="selectCustomSign(1)">
                 <img src="../../static/images/custom/ft2.png" class="focus-img-f" v-show="customindex==1">
                <img src="../../static/images/custom/ft2-1.png" class="focus-img-f" v-show="customindex!=1">
                <span class="focus-img-text" tips="智能物料柜">{{ langs.cust24 }}</span>
              </li>
              <li :class="customindex==2?'custom-sign':'custom-sign-hide'" @click="selectCustomSign(2)">
                 <img src="../../static/images/custom/ft3.png" class="focus-img-f" v-show="customindex==2">
                <img src="../../static/images/custom/ft3-1.png" class="focus-img-f" v-show="customindex!=2">
                <span class="focus-img-text" tips="智能钥匙柜">{{ langs.cust25 }}</span>
              </li>
              <li :class="customindex==3?'custom-sign':'custom-sign-hide'" @click="selectCustomSign(3)">
                 <img src="../../static/images/custom/ft4.png" class="focus-img-f" v-show="customindex==3">
                <img src="../../static/images/custom/ft4-1.png" class="focus-img-f" v-show="customindex!=3">
                <span class="focus-img-text" tips="迷你售货机">{{ langs.cust26 }}</span>
              </li>
              <li :class="customindex==4?'custom-sign':'custom-sign-hide'" @click="selectCustomSign(4)">
                 <img src="../../static/images/custom/ft5.png" class="focus-img-f" v-show="customindex==4">
                <img src="../../static/images/custom/ft5-1.png" class="focus-img-f" v-show="customindex!=4">
                <span class="focus-img-text" tips="综合售货机">{{ langs.cust27 }}</span>
              </li>
            </ul>
          </div>
          <div class="custom-trans-box">
            <img src="../../static/images/custom/f1.png" alt="" class="custom-trans" :class="customindex==0?'':'custom-hide'">
            <img src="../../static/images/custom/f2.png" alt="" class="custom-trans" :class="customindex==1?'':'custom-hide'">
            <img src="../../static/images/custom/f3.png" alt="" class="custom-trans" :class="customindex==2?'':'custom-hide'">
            <img src="../../static/images/custom/f4.png" alt="" class="custom-trans" :class="customindex==3?'':'custom-hide'">
            <img src="../../static/images/custom/f5.png" alt="" class="custom-trans" :class="customindex==4?'':'custom-hide'">
          </div>
          <!--右下角介绍-->
          <div class="custom-recomm">

          </div>
        </div>
        <div class="focus-img focus-img-sm">
          <div class="focus-img-t">
            <ul>
              <li :class="customindex==0?'custom-sign':'custom-sign-hide'" @click="selectCustomSign(0)">
                <img src="../../static/images/custom/ft1.png" class="focus-img-f" v-show="customindex==0">
                <img src="../../static/images/custom/ft1-1.png" class="focus-img-f" v-show="customindex!=0">
                <span class="focus-img-text" tips="智能餐柜">{{ langs.cust23 }}</span>
              </li>
              <li :class="customindex==1?'custom-sign':'custom-sign-hide'" @click="selectCustomSign(1)">
                <img src="../../static/images/custom/ft2.png" class="focus-img-f" v-show="customindex==1">
                <img src="../../static/images/custom/ft2-1.png" class="focus-img-f" v-show="customindex!=1">
                <span class="focus-img-text" tips="智能物料柜">{{ langs.cust24 }}</span>
              </li>
              <li :class="customindex==2?'custom-sign':'custom-sign-hide'" @click="selectCustomSign(2)">
                <img src="../../static/images/custom/ft3.png" class="focus-img-f" v-show="customindex==2">
                <img src="../../static/images/custom/ft3-1.png" class="focus-img-f" v-show="customindex!=2">
                <span class="focus-img-text" tips="智能钥匙柜">{{ langs.cust25 }}</span>
              </li>
              <li :class="customindex==3?'custom-sign':'custom-sign-hide'" @click="selectCustomSign(3)">
                <img src="../../static/images/custom/ft4.png" class="focus-img-f" v-show="customindex==3">
                <img src="../../static/images/custom/ft4-1.png" class="focus-img-f" v-show="customindex!=3">
                <span class="focus-img-text" tips="迷你售货机">{{ langs.cust26 }}</span>
              </li>
              <li :class="customindex==4?'custom-sign':'custom-sign-hide'" @click="selectCustomSign(4)">
                <img src="../../static/images/custom/ft5.png" class="focus-img-f" v-show="customindex==4">
                <img src="../../static/images/custom/ft5-1.png" class="focus-img-f" v-show="customindex!=4">
                <span class="focus-img-text" tips="综合售货机">{{ langs.cust27 }}</span>
              </li>
            </ul>
          </div>
          <div class="custom-trans-box">
            <img src="../../static/images/custom/f1.png" alt="" class="custom-trans" :class="customindex==0?'':'custom-hide'">
            <img src="../../static/images/custom/f2.png" alt="" class="custom-trans" :class="customindex==1?'':'custom-hide'">
            <img src="../../static/images/custom/f3.png" alt="" class="custom-trans" :class="customindex==2?'':'custom-hide'">
            <img src="../../static/images/custom/f4.png" alt="" class="custom-trans" :class="customindex==3?'':'custom-hide'">
            <img src="../../static/images/custom/f5.png" alt="" class="custom-trans" :class="customindex==4?'':'custom-hide'">
          </div>
          <!--右下角介绍-->
          <div class="custom-recomm">

          </div>
        </div>
      </div>
    </div>
    <div class="show-box">
      <div class="technology-box">
        <div class="tech-title content-title" style="font-size: 14px;">
          <h1 class="wow animate__animated animate__fadeInUp animate__delay-0.3s tech-title-sm" tips="颜色/组合/软件/硬件 支持定制">
            {{ langs.cust41 }}</h1>
          <div class="show-color-box">
            <div class="show-color-list" :class="showindex==0?'curr-show-color':''" style="background: #134fae;" @click="selectShowImage(0)"></div>
            <div class="show-color-list" :class="showindex==1?'curr-show-color':''" style="background: #bd2930;" @click="selectShowImage(1)"></div>
            <div class="show-color-list" :class="showindex==2?'curr-show-color':''" style="background: #ffef3f;" @click="selectShowImage(2)"></div>
            <div class="show-color-list" :class="showindex==3?'curr-show-color':''" style="background: #55ff24;" @click="selectShowImage(3)"></div>
            <div class="show-color-list" :class="showindex==4?'curr-show-color':''" style="background: #ffae27;" @click="selectShowImage(4)"></div>
          </div>
        </div>
      </div>
      <div class="show-image">
        <div class="show-image-box">
          <img src="../../static/images/custom/s1.png" alt="" class="show-trans" :class="showindex==0?'':'show-hide'">
          <img src="../../static/images/custom/s2.png" alt="" class="show-trans" :class="showindex==1?'':'show-hide'">
          <img src="../../static/images/custom/s3.png" alt="" class="show-trans" :class="showindex==2?'':'show-hide'">
          <img src="../../static/images/custom/s4.png" alt="" class="show-trans" :class="showindex==3?'':'show-hide'">
          <img src="../../static/images/custom/s5.png" alt="" class="show-trans" :class="showindex==4?'':'show-hide'">
        </div>
      </div>
    </div>
    <!--定制流程-->
    <div class="custom-flow">
      <!-- 大屏 适应 -->
      <div class="container custom-bg">
        <div class="technology-box">
          <div class="tech-title content-title" style="font-size: 14px;color: #fff;">
            <h1 class="wow animate__animated animate__fadeInUp animate__delay-0.3s" tips="定制流程">{{ langs.cust28 }}</h1>
          </div>
        </div>
        <el-row>
          <el-col :md="1">
            <div class="flow-btn-left" @click="clickChangeFlow()"><i class="el-icon-arrow-left" :class="flowindex==0?'nodrop':''"></i></div>
          </el-col>
          <el-col :md="10">
            <div class="flow-text" v-show="flowindex==0">
              <div class="flow-text-seqno"><p>1</p></div>
              <div class="flow-text-i"><p></p></div>
              <div class="flow-text-c">
                <p tips="一对一专业销售人员">{{ langs.cust29 }}</p>
                <p tips="7天24小时响应">{{ langs.cust30 }}</p>
              </div>
            </div>
            <div class="flow-text" v-show="flowindex==1">
              <div class="flow-text-seqno"><p>2</p></div>
              <div class="flow-text-i"><p></p></div>
              <div class="flow-text-c">
                <p tips="经验丰富的设计师">{{ langs.cust31 }}</p>
                <p tips="完美解决客户需求">{{ langs.cust32 }}</p>
              </div>
            </div>
            <div class="flow-text" v-show="flowindex==2">
              <div class="flow-text-seqno"><p>3</p></div>
              <div class="flow-text-i"><p></p></div>
              <div class="flow-text-c">
                <p tips="从下单到制造，全程跟踪">{{ langs.cust33 }}</p>
              </div>
            </div>
            <div class="flow-text" v-show="flowindex==3">
              <div class="flow-text-seqno"><p>4</p></div>
              <div class="flow-text-i"><p></p></div>
              <div class="flow-text-c">
                <p tips="专业的测试团队">{{ langs.cust34 }}</p>
                <p tips="在发货前会对软件及硬件进行全方位检测">{{ langs.cust35 }}</p>
              </div>
            </div>
            <div class="flow-text" v-show="flowindex==4">
              <div class="flow-text-seqno"><p>5</p></div>
              <div class="flow-text-i"><p></p></div>
              <div class="flow-text-c">
                <p tips="合作愉快">{{ langs.cust36 }}</p>
              </div>
            </div>
          </el-col>
          <el-col :md="12" class="">
            <div class="flow-img-box">
              <div class="flow-text-img" :class="flowindex==0?'':'flow-hide'"><img src="../../static/images/custom/w1.png" alt=""></div>
              <div class="flow-text-img" :class="flowindex==1?'':'flow-hide'"><img src="../../static/images/custom/w2.png" alt=""></div>
              <div class="flow-text-img" :class="flowindex==2?'':'flow-hide'"><img src="../../static/images/custom/w3.png" alt=""></div>
              <div class="flow-text-img" :class="flowindex==3?'':'flow-hide'"><img src="../../static/images/custom/w4.png" alt=""></div>
              <div class="flow-text-img" :class="flowindex==4?'':'flow-hide'"><img src="../../static/images/custom/w5.png" alt=""></div>
            </div>
          </el-col>
          <el-col :md="1">
            <div class="flow-btn-left" @click="clickAddFlow()"><i class="el-icon-arrow-right" :class="flowindex==4?'nodrop':''"></i></div>
          </el-col>
        </el-row>
        <div class="custom-flow-list">
          <el-steps :active="flowindex+1">
            <el-step class="flow-list-s" :title="langs.cust37" icon="el-icon-phone-outline"></el-step>
            <el-step class="flow-list-s" :title="langs.cust38" icon="el-icon-edit"></el-step>
            <el-step class="flow-list-s" :title="langs.cust39" icon="el-icon-shopping-cart-2"></el-step>
            <el-step class="flow-list-s" :title="langs.cust40" icon="el-icon-s-data"></el-step>
            <el-step class="flow-list-s" :title="langs.cust36" icon="el-icon-s-promotion"></el-step>
          </el-steps>
        </div>
      </div>
      <!-- 小屏 适应 -->
      <div class="container custom-sm">
        <div class="technology-box">
          <div class="tech-title content-title" style="font-size: 14px;color: #fff;">
            <h1 class="wow animate__animated animate__fadeInUp animate__delay-0.3s" tips="定制流程">{{ langs.cust28 }}</h1>
          </div>
        </div>
        <el-row>
          <el-col :md="24">
            <div class="flow-text" v-show="flowindex==0">

              <div class="flow-text-img"><img src="../../static/images/custom/w1.png" alt=""></div>
              <div class="flow-text-seqno"><p>1</p>{{ langs.cust37 }}</div>
              <div class="flow-text-i"><p></p></div>
              <div class="flow-text-c">
                <p tips="一对一专业销售人员">{{ langs.cust29 }}</p>
                <p tips="7天24小时响应">{{ langs.cust30 }}</p>
              </div>
            </div>
            <div class="flow-text" v-show="flowindex==1">
              <div class="flow-text-img"><img src="../../static/images/custom/w2.png" alt=""></div>
              <div class="flow-text-seqno"><p>2</p>{{ langs.cust38 }}</div>
              <div class="flow-text-i"><p></p></div>
              <div class="flow-text-c">
                <p tips="经验丰富的设计师">{{ langs.cust31 }}</p>
                <p tips="完美解决客户需求">{{ langs.cust32 }}</p>
              </div>
            </div>
            <div class="flow-text" v-show="flowindex==2">
              <div class="flow-text-img"><img src="../../static/images/custom/w3.png" alt=""></div>
              <div class="flow-text-seqno"><p>3</p>{{ langs.cust39 }}</div>
              <div class="flow-text-i"><p></p></div>
              <div class="flow-text-c">
                <p tips="从下单到制造，全程跟踪">{{ langs.cust33 }}</p>
              </div>
            </div>
            <div class="flow-text" v-show="flowindex==3">
              <div class="flow-text-img"><img src="../../static/images/custom/w4.png" alt=""></div>
              <div class="flow-text-seqno"><p>4</p>{{ langs.cust40 }}</div>
              <div class="flow-text-i"><p></p></div>
              <div class="flow-text-c">
                <p tips="专业的测试团队">{{ langs.cust34 }}</p>
                <p tips="在发货前会对软件及硬件进行全方位检测">{{ langs.cust35 }}</p>
              </div>
            </div>
            <div class="flow-text" v-show="flowindex==4">
              <div class="flow-text-img"><img src="../../static/images/custom/w5.png" alt=""></div>
              <div class="flow-text-seqno"><p>5</p>{{ langs.cust36 }}</div>
              <div class="flow-text-i"><p></p></div>
              <div class="flow-text-c">
                <p tips="合作愉快">{{ langs.cust36 }}</p>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
    <div class="custom-map">
      <div class="custom-map-box">
        <img src="../../static/images/custom/m-zh.png" alt="" class="map-trans" v-show="currlangs==0">
        <img src="../../static/images/custom/m-eng.png" alt="" class="map-trans" v-show="currlangs==1">
        <img src="../../static/images/custom/m-sp.png" alt="" class="map-trans" v-show="currlangs==2">
      </div>
    </div>
	</div>
</template>

<script>
	import { WOW } from 'wowjs'
	export default{
		data() {
			return{
				showLoading: true,

				currlangs: 0, //0中文 1英文 2西班牙语
				langs: zh,

        customindex: 0, //专注更专业 - 商品图
        showindex: 0, //颜色 - 商品图

        flowindex: 0,
			}
		},
		created() {
			let _this = this;
			setTimeout(() => {
				_this.showLoading = false;
			}, 500)
		},
		mounted() {
      // console.info(this.$route.path);
			let _this = this;

			_this.currlangs = sessionStorage.getItem('UPUS_langs');
			if(_this.currlangs == 2) {
				_this.langs = sp;
			} else if(_this.currlangs == 1) {
				_this.langs = eng;
			} else {
				_this.langs = zh;
			}

      setInterval(function () {
        _this.showindex++;
        if(_this.showindex > 4) {
          _this.showindex = 0;
        }
      }, 3500)

      setInterval(function () {
        _this.customindex++;
        if(_this.customindex > 4) {
          _this.customindex = 0;
        }
      }, 5000)

      setInterval(function () {
        _this.flowindex++;
        if(_this.flowindex > 4) {
          _this.flowindex = 0;
        }
      }, 4000)

		},
    methods: {
      // 选择不同的智能柜类型
      selectCustomSign(index) {
        this.customindex = index;
      },
      // 选择不同的颜色类型
      selectShowImage(index) {
        this.showindex = index;
      },
      // 定制流程
      clickChangeFlow() {
        let _this = this;
        if(_this.flowindex > 0) {
          _this.flowindex--;
        }
      },
      clickAddFlow() {
        let _this = this;
        if(_this.flowindex < 4) {
          _this.flowindex++;
        }
      },
    }
	}
</script>

<style scoped>
	.custom-1-tit{
		margin: 50px 0px;
		text-align: center;
	}
  h1, h2, h3{
    margin: 0px;
    font-weight:500;
    letter-spacing: 5px;
  }
  .content-title{
    color: #000;
    text-align: center;
    padding: 40px 0px 30px;
    font-size: 16px;
  }
  .tech-text-d{
    width: 100%;
    height: 200px;
    background-image: url("../../static/images/custom/tech-bg-1.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;
    margin-bottom: 20px;
    cursor: pointer;
  }
  .d-box{
    padding: 24px;
  }
  .d-under{
    width: 40px;
    height: 3px;
    background: #81a2ff;
    margin: 8px 0px 12px;
    border-radius: 2px;
  }
  .d-title{
    font-size: 19px;
    font-weight: 600;
  }
  .d-text{
    font-size: 14px;
    line-height: 22px;
    padding-right: 20%;
  }
  .d-img{
    width: 120px;
    height: 105px;
    text-align: center;
    margin: 30px auto 0px;
    line-height: 200px;
  }
  .d-img img{
    transition: 0.3s;
  }
  .tech-text-d:hover .d-img img{
    transform: scale(1.2);
  }
  .focus-title{
    background: #fff;
    padding: 40px 0px;
  }
  .focus-title h1{
    margin-bottom: 20px;
  }
  .focus-title div{
    font-size: 20px;
    letter-spacing: 3px;
  }
  .focus-img{
    position: relative;
  }
  .focus-img-t{
    position: absolute;
    left: 10%;
    top: 10%;
  }
  .focus-img-t li{
    width: 150px;
    margin: 20% 0px;
    position: relative;
    cursor: pointer;
  }
  .focus-img-f{
    width: 50px;
    height: 50px;
    position: absolute;
    z-index: 9;
  }
  .focus-img-text{
    display: inline-block;
    width: 230px;
    height: 35px;
    line-height: 35px;
    background: #fff;
    border-radius: 20px;
    margin-left: 30px;
    margin-top: 8px;
    text-align: left;
    z-index: 8;
    position: inherit;
    padding-left: 30px;
  }
  .custom-trans-box{
    position: relative;
    height: 600px;
  }
  .custom-trans{
    position: absolute;
    left: 0px;
    top: 0px;
    transition: 1s;
  }
  .custom-hide{
    opacity: 0;
  }
  .custom-sign-hide .focus-img-text{
    background: #535353;
    color: #c2c2c2;
  }
  .show-box{
    background: #fff;
    padding-bottom: 50px;
    position: relative;
    height: 650px;
  }
  .show-color-box{
    width: 100%;
    height: 35px;
    text-align: center;
    margin-top: 25px;
  }
  .show-color-list{
    display: inline-block;
    width: 32px;
    height: 32px;
    border-radius: 50%;
    margin: 0px 20px;
    cursor: pointer;
    box-sizing: border-box;
  }
  .curr-show-color{
    border: 4px solid #eee;
  }
  .show-image{
    text-align: center;
    position: relative;
    height: 520px;
  }
  .show-image-box{
    width: 700px;
    height: 500px;
    display: flex;
    margin: 0px auto;
  }
  .show-trans{
    position: absolute;
    top: 0px;
    transition: 1s;
    width: 700px;
    height: 500px;
  }
  .show-hide{
    opacity: 0;
  }
  .custom-flow{
    height: 700px;
    background: url("../../static/images/custom/f-bg.png");
  }
  .custom-map-box{
    width: 100%;
    height: 700px;
  }
  .flow-text{
    text-align: center;
    color: #fff;
    margin-top: 10%;
  }
  .flow-text-seqno p{
    display: inline-block;
    font-size: 18px;
    border: 1px solid #fff;
    width: 30px;
    height: 30px;
    line-height: 30px;
    border-radius: 50%;
  }
  .flow-text-i p{
    display: inline-block;
    border-left: 1px solid #fff;
    height: 30px;
    margin: 0px;
  }
  .flow-text-c p{
    font-size: 18px;
  }
  .flow-text-img{
    width: 500px;
  }
  .custom-flow-list{
    margin-top: 8%;
  }
  .flow-list-s{
    cursor: pointer;
  }
  .flow-btn-left{
    font-size: 20px;
    line-height: 320px;
  }
  .flow-btn-left i{
    padding: 5px;
    border-radius: 50%;
    border: 1px solid #fff;
    color: #fff;
    font-width: 900;
    cursor: pointer;
  }
  .flow-btn-left i.nodrop{
    color: #eee;
    cursor: no-drop;
  }
  .flow-img-box{
    position: relative;
    height: 320px;
  }
  .flow-text-img{
    position: absolute;
    top: 0px;
    left: 0px;
    transition: 0.3s;
  }
  .flow-hide{
    opacity: 0;
  }
  .focus-img-sm{
    display: none;
  }
  .custom-sm{
    display: none;
  }
  @media screen and (max-width:768px) {
    .d-img{
      width: 80px;
      height: 65px;
    }
    .d-text{
      padding-right: 5%;
    }
    .tech-title-sm{
      font-size: 12px;
    }
    .focus-img-bg{
      display: none;
    }
    .focus-img-sm{
      display: block;
    }
    .custom-bg{
      display: none;
    }
    .custom-sm{
      display: block;
    }
    .custom-trans-box{
      min-height: 160px;
      height: 160px;
    }
    .focus-img-t{
      position: unset;
    }
    .focus-img-t ul{
      padding: 12px 10px;
      text-align: center;
      margin: 0px auto;
      display: flex;
      height: 50px;
    }
    .focus-img-t li {
      width: 150px;
      margin: 0px;
      position: relative;
      cursor: pointer;
    }
    .custom-sign-hide{
      display: none;
    }
    .show-box{
      height: 500px;
    }
    .show-image-box img{
      width: 100%;
      height: auto;
    }
    .show-image{
      height: 300px;
    }
    .show-image-box{
      width: 100%;
      height: 300px;
    }
    .flow-text-img{
      width: 90%;
      margin: 0px 5%;
      position: unset;
    }
    .flow-text-seqno p{
      margin-right: 12px;
    }
    .custom-flow{
      height: 600px;
    }
    .custom-map-box{
      min-height: 150px;
      height: 150px;
    }
  }

	/* .custom-1-tit h1{
		font-size: 40px;
		font-weight: 500;
		color: #409EFF;
	}
	.custom-1 .el-col{
		text-align: center;
		padding: 50px;
	}
	.custom-1-list{
		transition: 0.3s;
		padding: 20px 0px 40px;
		box-sizing: border-box;
		position: relative;
		border: 1px solid #ccc;
		cursor: pointer;
		min-height: 380px;
	}
	.list-image{
		width: 138px;
		position: absolute;
		left: 50%;
		top: -70px;
		margin-left: -69px;
	}
	.custom-1 .el-col:hover .custom-1-list{
		margin-top: -12px;
		border: 1px solid #409EFF;
	}
	.list-image{
		width: 138px;
		margin: 0px auto;
	}
	.list-text h2{
		font-size: 25px;
	}
	.list-text div{
		font-size: 20px;
	}
	.list-text{
		margin: 0px 0px 30px;
	}
	.custom-2{
		margin: 50px 0px 80px;
	}
	.custom-2 .el-col{
		padding:0px 20px;
	}
	.custom-2-1{
		width: 100%;
		height: 410px;
		text-align: center;
	}
	.custom-2-1 h2{
		display: inline-block;
		width: 100%;
		font-size: 35px;
		color: #fff;
		margin: 150px 0px 20px;
		font-weight: 100;
	}
	.custom-2-1 div{
		font-size: 27px;
		color: #bbb;
	}
	.custom-2-list{
		padding: 10px 5px;
	}
	.custom-2-list:nth-child(1) {
		border-bottom: 1px solid #ccc;
	}
	.custom-2-img{
		//transform: scale(0.5);
		width: 150px;
	}
	.custom-2-list img{
		//transform: scale(0.8);
	}
	.custom-2-type{
		text-align: right;
	}
	.custom-2-type h3{
		color: #777;
		font-size: 28px;
		margin: 0px;
		font-weight: 100;
	}
	.custom-2-type div{
		color: #999;
		font-size: 24px;
	}
	.custom-list{
		border-right: 1px solid #ccc;
	}
	@media screen and (max-width:768px) {
		.custom-1 .el-col{
			padding: 20px 50px;
		}
		.custom-2-1{
			height: 150px;
		}
		.custom-2-1 h2{
			margin-top: 20px;
		}
		.custom-2-list{
			border-bottom: 1px solid #ccc;
		}
		.custom-2{
			margin: 50px 0px 50px;
		}
	} */
</style>



// WEBPACK FOOTER //
// src/views/custom.vue